export const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(value);
  }

  return parsedDate.toLocaleString();
};

export const formatUsageChemicalName = (value = "") =>
  String(value).replace(/([A-Za-z0-9₀-₉])\(/gu, "$1 (");

const getFirstValidTrain = (trainList = []) => {
  const list = Array.isArray(trainList) ? trainList : [];
  const firstTrain = list.find((train) => Number(train) > 0);
  return firstTrain ? Number(firstTrain) : null;
};

export const getUsageOpenUrl = (row, origin = "") => {
  const plantId = row?.plantId;
  if (!plantId) {
    return "";
  }

  const queryParams = new URLSearchParams({
    plantId: String(plantId),
    isEdit: "true",
  });

  const isPlantUsage = row?.isPlantUsage ?? row?.is_plant;
  const isCipUsage = row?.isCipUsage ?? row?.is_cip;
  const isDefaultCipUsage = row?.isDefaultCipUsage ?? row?.is_default_cip;

  if (isPlantUsage) {
    return `${origin}/editPlant?${queryParams.toString()}`;
  }

  if (isCipUsage || isDefaultCipUsage) {
    const preferredTrain =
      getFirstValidTrain(row?.cipTrains) ||
      getFirstValidTrain(row?.defaultCipTrains) ||
      1;

    queryParams.set("sel_train", String(preferredTrain));
    return `${origin}/analyseData?${queryParams.toString()}`;
  }

  return "";
};

export const mapUsageRows = (usageList = [], t) =>
  (Array.isArray(usageList) ? usageList : [])
    .map((item) => {
      const plantUsageId = item?.plant_id;
      const trainsList = Array.isArray(item?.trains)
        ? item.trains.map((train) => String(train).trim()).filter(Boolean)
        : [];

      return {
        id: plantUsageId,
        plantId: plantUsageId,
        plantName: item?.plant_name ?? "-",
        lastModified: item?.last_modified,
        createdDate: item?.created_at,
        isPlantUsage: item?.is_plant,
        isDefaultCipUsage: item?.is_default_cip,
        isCipUsage: item?.is_cip,
        defaultCipTrains: Array.isArray(item?.default_cip_trains)
          ? item?.default_cip_trains
          : [],
        cipTrains: Array.isArray(item?.cip_trains) ? item?.cip_trains : [],
        trains: trainsList.length
          ? trainsList.join(", ")
          : t("chemicalLibrary.usageNoTrains"),
      };
    })
    .filter((item) => item.plantId);
